import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function Cupcakes() {

    const heroData = [
        {
          title: "Cupcakes",
          content: "Our cupcakes are tiny bundles of joy, featuring moist cakes topped with rich, creamy frostings and delightful decorations. Perfect for sharing, gifting, or indulging yourself!",
          image: images.CupcakesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Classic Vanilla Cupcake",
        content: "Light and flu y vanilla cupcake topped with creamy buttercream",
        price: 0,
        image: [
          images.Cupcake1,
        ]
      },
      {
        name: "Chocolate Cupcake",
        content: "Moist chocolate cupcake with rich chocolate frosting",
        price: 0,
        image: [
          images.Cupcake2,
        ]
      },
      {
        name: "Carrot Cupcake",
        content: "Spiced carrot cupcake topped with cream cheese frosting",
        price: 0,
        image: [
          images.Cupcake3,
        ]
      },
      {
        name: "Red Velvet Cupcake",
        content: "Velvety red cupcake with a tangy cream cheese frosting ",
        price: 0,
        image: [
          images.Cupcake4,
        ]
      },
      {
        name: "Hazelnut Chocolate Cupcake",
        content: "Moist cake infused with hazelnuts, chocolate ganache and topped with crushed hazelnuts",
        price: 0,
        image: [
          images.Cupcake5,
        ]
      },
      {
        name: "Maple Pecan Cupcake",
        content: "Buttermilk cake infused with maple syrup, pecan nuts and maple butter frosting",
        price: 0,
        image: [
          images.Cupcake5,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Carrot Cupcake",
        image1: [
          images.Cupcake3,
        ],
        content1: "Spiced carrot cupcake topped with cream cheese frosting",
        name2: "Maple Pecan Cupcake",
        image2: [
          images.Cupcake5,
        ],
        content2: "Buttermilk cake infused with maple syrup, pecan nuts and maple butter frosting"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
